export const MessageDirection = Object.freeze({
  INBOUND: 0,
  OUTBOUND: 1,
})
